import React from 'react';
import PropTypes from 'prop-types';

const ProgressBar = props => {
  const {className, progress, max, background, color} = props
  return (
    <progress
      style={{
        '--background-color': background,
        '--progress-color': color,
      }}
      className={`progress-bar ${className}`}
      value={progress}
      max={max}
    />
  );
};

ProgressBar.propTypes = {
  className: PropTypes.string,
  progress: PropTypes.number,
  max: PropTypes.number,
  background: PropTypes.string,
  color: PropTypes.string,
};

ProgressBar.defaultProps = {
  className: '',
  progress: 0,
  max: 100,
  background: 'var(--blue-50)',
  color : 'var(--blue-500)',
}

export default ProgressBar;
